import { defaultDownloadUrl } from '@@/config';
import { useMultiSound } from '@@/hooks';
import { isIOS } from '@@/utils';
import { xiyueSounds } from '@/src/config';
import styles from './style.module.scss';

const NavBar = ({
  selectedIndex,
  setSelectedIndex,
  downloadData,
}) => {
  const [soundsAction, soundsStatus] = useMultiSound(xiyueSounds);

  const onSwitchPlay = () => {
    if (soundsStatus['bg']) {
      soundsAction.pause('bg');
    } else {
      soundsAction.play('bg');
    }
  };

  const onDownload = () => {
    const url = isIOS() ?
      downloadData.dIos || defaultDownloadUrl.dIos :
      downloadData.dAndroid || defaultDownloadUrl.dAndroid;
    window.open(url);
  };

  const onToHome = () => {
    window.location.assign('/home');
  };

  return (
    <header className={styles.container}>
      <div className={styles.midWrap}>
        <div className={styles.logo} onClick={() => setSelectedIndex(0)} />
        <div className={styles.navList}>
          <a
            className={`${styles.navItem} ${selectedIndex === 0 ? styles.active : ''}`}
            onClick={() => { setSelectedIndex(0); }}
          >
            坠月之宴
          </a>
          <a
            className={`${styles.navItem} ${selectedIndex === 1 ? styles.active : ''}`}
            onClick={() => { setSelectedIndex(1); }}
          >
            世界故事
          </a>
          <a
            className={`${styles.navItem} ${selectedIndex === 2 ? styles.active : ''}`}
            onClick={() => { setSelectedIndex(2); }}
          >
            羁绊角色
          </a>
          <a
            className={`${styles.navItem} ${selectedIndex === 3 ? styles.active : ''}`}
            onClick={() => { setSelectedIndex(3); }}
          >
            西月百态
          </a>
          <a
            className={`${styles.navItem} ${selectedIndex === 4 ? styles.active : ''}`}
            onClick={() => { setSelectedIndex(4); }}
          >
            记忆长廊
          </a>
        </div>
        <a className={styles.downloadBtn} onClick={onDownload} />
        <a className={styles.toHomeBtn} onClick={onToHome} />
        <div className={styles.voiceTitle} />
        <div
          className={`${styles.playBtn} ${soundsStatus.bg ? styles.active : ''}`}
          onClick={onSwitchPlay}
        >
          <i /><i /><i /><i /><i />
        </div>
      </div>
    </header>
  );
};

export default NavBar;
